<div class="question-carousel__container">
  <empathy-cards-form></empathy-cards-form>
  <empathy-rating-values-form></empathy-rating-values-form>
</div>
